export default "__VITE_ASSET__$HxVzIqa__"